const menuCont = document.querySelector('.site-menu__cont')
const parent = document.querySelectorAll('.has-children > a')
const background = document.querySelector('.site-menu__background')
const closeButton = document.querySelector('.mobile-buttons__close')
const backButton = document.querySelector('.mobile-buttons__back')
const mobileButton = document.querySelector('.mobile-button')

var dataLevel = 0
var menuOpen = false

function openParent() {
	var parentOpen = this.parentElement.classList.contains('open')
	const navigation = this.closest('.site-menu[data-level="1"]') || this.parentElement.querySelector('.site-menu[data-level="1"]')

	if (!parentOpen) {
		// Remove 'open' class from sibling elements
		let menuLevel = parseInt(this.parentElement.getAttribute('data-level'))
		const menuLevels = document.querySelectorAll('[data-level="'+menuLevel+'"]')

		menuLevels.forEach(function(el) {
			el.classList.remove('open')
			el.classList.remove('state')
			el.classList.remove('menu-open')

			// Close child items
			const menuItems = el.querySelectorAll('.has-children.open') 
			menuItems.forEach(function(el) {
				animateOut(el)
			});	
		});

		animateIn(background)
		animateIn(this.parentElement)

		let navMinHeight = 0
		const visibleMenus = document.querySelectorAll('.menu-open > .site-menu')	
		const navRectPrev = navigation.getBoundingClientRect()
		navigation.style.minHeight = ''
		visibleMenus.forEach(function(el) {
			const rect = el.getBoundingClientRect()
			if (rect.height >= navMinHeight) navMinHeight = rect.height
		})
		navigation.style.minHeight = navRectPrev.height + 'px'
		navigation.getBoundingClientRect()
		navigation.style.minHeight = navMinHeight + 'px'
	} 
}

function closeNav() {
	dataLevel = 0
	const menuItems = document.querySelectorAll('.has-children.open') // select all open nav items
	menuItems.forEach(function(el) {
		animateOut(el)
	});
	closeMenu()
	animateOut(background)
}

function dataCount() {
	dataLevel = dataLevel + 1
}

function backLevel() {
	// console.log(dataLevel)
	if (dataLevel === 0) {
		closeNav()
	} else {
		dataLevel = dataLevel - 1
		const menuTest = document.querySelectorAll('[data-level="'+dataLevel+'"]')

		// console.log(menuTest)
		menuTest.forEach(function(el) {
			// el.classList.remove('open')
			animateOut(el)
		});
	}
}

function toggleNav() {
	menuOpen ? closeMenu() : openMenu()
}

function openMenu() {
	menuOpen = true
	animateIn(menuCont)
}

function closeMenu() {
	menuOpen = false
	animateOut(menuCont)
}

// function toggleNav() {
// 	menuCont.classList.toggle('active')
// }

// Event listeners
parent.forEach(function(el) {
	el.addEventListener('click', openParent);
	el.addEventListener('click', dataCount);
	el.addEventListener("click", function(event){
		event.preventDefault()
	});
});

background.addEventListener('click', closeNav)
closeButton.addEventListener('click', closeNav)
backButton.addEventListener('click', backLevel)
mobileButton.addEventListener('click', toggleNav)


// detect esc key
window.addEventListener('keydown', event => {
	const escKey = (event.key === 'Escape' || event.keyCode === 27)
	const isOpen = document.querySelector('.has-children.open') !== null
	if (escKey && isOpen) closeNav()
})



// Animation and timeotes

function animateIn(el) {
	el.classList.add('menu-open')
	el.classList.add('state')
	setTimeout(() => {
		el.classList.add('open') // display none
	}, 200); // transform - 100px
}

function animateOut(el) {
	el.classList.remove('menu-open')
	el.classList.remove('open') // display none
	setTimeout(() => {
		el.classList.remove('state')
	}, 200); // transform - 100px
}

// function toggle() {
// 	isOpen ? close() : open()
// }


// function toggle() {
// 	this.parentElement.classList.toggle('open')
// 	// console.log('meh')
// }



// function test() {

// 	this.parentElement.classList.toggle('open')
// 	// console.log(this)
// 	// this.parent.classList.toggle('open')
// }

// child.forEach(function(el) {
// 	el.addEventListener('click', test);
// });


// function init() {

// 	function openNav() {
// 		console.log('hello')
// 	}


// 	// parents.(parent => parent.addEventListener('click', openNav))
// }


// export default () => {
// 	init()
//     // const menuItems = [...document.querySelectorAll('.site-menu__item')]
//     // menuItems.map(init)
// }




// function init(el) {
//     const tabs = [...el.querySelectorAll('.ci-tab')]
    
//     function openTab() {
//         const tabActive = el.querySelector('.ci-tab.active')
//         const tabContentActive = el.querySelector('.ci-content.active')
        
//         const tabID = this.getAttribute('data-tab')
//         const newTab = el.querySelector('#' + tabID)
        
//         // Remove current active state and reinstate current
//         tabContentActive.classList.remove('active');
//         newTab.classList.add('active');

//         // Remove current active state and reinstate current
//         tabActive.classList.remove('active');
//         this.classList.add('active');    
//     }
    
//     tabs.map(tab => tab.addEventListener('click', openTab))
// }

// export default () => {
//     const tabbed = [...document.querySelectorAll('.ci-tabbed-content')]
//     tabbed.map(init)
// }









// const parent = document.querySelectorAll('.has-children')

// function open(el) {
// 	// const parents = [...el.querySelectorAll('.has-children')]
// 	console.log(el)
// 	//  
// }

    // const tabbed = [...document.querySelectorAll('.has-children')]
	// console.log(tabbed)


// function blah() {
// 	console.log('who knows')
// 	const navActive = parent.querySelectorAll('has-children.open')
// }



// parent.addEventListener('click', open(parent))


// const parent = document.querySelector('.has-children')
// const parentLink = document.querySelector('.has-children a')


// console.log('help')

// function init (el) {
// 	console.log(el)
// 	const navActive = el.querySelector('has-children.open')
// 	console.log(navActive)



// }


// export default () => {
//     const parents = [...document.querySelectorAll('.has-children')]
//     parents.map(init)
// }

// console.log(parent)

// // let isOpen = false
// // let timeout = false

// // function close() {
// // 	isOpen = false
// // 	parent.classList.remove('open')
// // }

// // function open() {
// // 	isOpen = true
// // 	parent.classList.add('open')
// // }

// // function toggle() {
// // 	isOpen ? close() : open()
// // }

// function disableLink(event) {
// 	event.preventDefault()
// }

// function open() {
// 	const active = 
// 	parent.classList.contains('open').classList.remove('open')


	// parent.classList.add('open')
	// console.log('blah')
// }

// // Event listeners
// parent.addEventListener('click', open)
// parentLink.addEventListener('click', disableLink)


// 1. if click on open parent item, close item
// 2. if click on closed parent item, remove .open from any other siblings and add to new one




// console.log(parent);


// // add event listeners 
// button.addEventListener('click', toggle)


// const button = document.querySelector('#nav-btn')
// const menu = document.querySelector('.menu')
// const menuBackground = document.querySelector('.menu__bg')
// const searchButton = document.querySelector('.site-header__links .search-apply')


// let isOpen = false
// let timeout = false

// function close() {
// 	isOpen = false
// 	button.classList.remove('open')
// 	menuBackground.classList.remove('open')
// 	menu.classList.remove('menu--open')
// 	timeout = setTimeout(function() {
// 		menu.style.display = 'none'
// 	}, 500)

// 	// allow scrolling on html element
// 	document.documentElement.classList.remove('overflow-hidden')
// }

// function open() {
// 	isOpen = true
// 	clearTimeout(timeout)

// 	// toggle button state
// 	button.classList.add('open')

// 	// toggle search button state
// 	menuBackground.classList.add('open')

// 	// animate menu in
// 	menu.style.display = 'block'
// 	menu.getBoundingClientRect()
// 	menu.classList.add('menu--open')

// 	// stop scrolling on html element
// 	document.documentElement.classList.add('overflow-hidden')

// }

// function toggle() {
// 	isOpen ? close() : open()
// }

// // add event listeners 
// button.addEventListener('click', toggle)
// menuBackground.addEventListener('click', close)

// // detect esc key
// window.addEventListener('keydown', event => {
// 	const escKey = (event.key === 'Escape' || event.keyCode === 27)
// 	const isOpen = menu.classList.contains('open')
// 	if (isOpen && escKey) toggle()
// })



//tabbed 




// function init(el) {

// 	const parents = [...el.querySelectorAll('.has-children')]

// 	console.log(parents)

//     function open() {
// 		const navActive = el.querySelector('has-children.open')

// 		console.log(parents)

//         const tabActive = el.querySelector('.ci-tab.active')
//         const tabContentActive = el.querySelector('.ci-content.active')
        
//         const tabID = this.getAttribute('data-tab')
//         const newTab = el.querySelector('#' + tabID)
        
//         // Remove current active state and reinstate current
//         tabContentActive.classList.remove('active');
//         newTab.classList.add('active');

//         // Remove current active state and reinstate current
//         tabActive.classList.remove('active');
//         this.classList.add('active');    
//     }
    
//     tabs.map(tab => tab.addEventListener('click', open))
// }

// export default () => {
//     const tabbed = [...document.querySelectorAll('.has-children')]
//     tabbed.map(init)

// 	console.log(tabbed)
// }
